import { Component, h, Listen, Prop, State, Host, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-career',
    styleUrl: 'sew-ws-career.scss',
    shadow: false,
})
export class SewWsCareer {
    @Element() el: HTMLSewWsCareerElement;
    @Prop({ reflect: true }) noGrid = false;
    @Prop({ reflect: true }) noMargin = false;
    @Prop() headline: string;
    @Prop() text: string;
    @Prop() subline: string;

    @State() inViewPort = false;

    @Listen('scroll', { target: 'window' })
    public handleScroll(): void {
        const top = this.element.getBoundingClientRect().top;

        if (top <= 350) {
            this.inViewPort = true;
        }
    }

    private element: HTMLElement;
    private slides: HTMLSewWsCareerSlideElement[];
    private activeSlide = 0;

    componentWillLoad(): void {
        this.slides = Array.from(
            this.el.querySelectorAll<HTMLSewWsCareerSlideElement>('sew-ws-career-slide')
        );
    }

    private setActiveSlide() {
        this.slides.forEach(slide => {
            slide.active = false;
        });

        if (this.activeSlide === this.slides.length) return;

        this.slides[this.activeSlide].active = true;
    }

    private slideWidthToCssVar() {
        this.el.style.setProperty('--slide-width', this.slides[0].clientWidth.toString());
    }

    public componentDidUpdate(): void {
        if (this.activeSlide === 0 && this.inViewPort) {
            this.slideWidthToCssVar();
            this.setActiveSlide();
            const slideInterval = setInterval(() => {
                this.activeSlide++;
                this.setActiveSlide();

                if (this.activeSlide === this.slides.length) {
                    clearInterval(slideInterval);
                }
            }, 3900);
        }
    }

    render() {
        return (
            <Host class="sew-ws-career" ref={el => (this.element = el)}>
                <h2 class="headline" innerHTML={this.headline}></h2>
                <div class="content">
                    <slot name="text" />
                    <p class="subline">{this.subline}</p>
                </div>
                <div class="image-wrapper">
                    <slot name="slide"></slot>
                    <div class="picture">
                        <slot name="picture"></slot>
                    </div>
                </div>

                <div class="buttons">
                    <slot name="buttons" />
                </div>
            </Host>
        );
    }
}
